import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

/** One open time a visitor can tap. Tapping it opens the sign-in step with that time picked. */
export const TimeChip = ({ className, ...props }: ComponentProps<"button">) => (
  <button
    type="button"
    className={cn(
      "inline-flex h-10 items-center justify-center rounded-xl bg-[var(--site-well)] px-3.5 text-[13px] font-medium whitespace-nowrap tabular-nums outline-none transition-[background-color,color,transform] hover:bg-primary hover:text-primary-foreground focus-visible:ring-2 focus-visible:ring-ring active:scale-[0.96]",
      className,
    )}
    {...props}
  />
);
